import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Meta } from '@angular/platform-browser';
import { WindowRefService } from '../service/window-ref/window-ref.service';
import { User } from '../types/entities/user.entity';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsService {
  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
    private meta: Meta,
    private windowRef: WindowRefService
  ) {}

  async getStarted(): Promise<void> {
    const apiUrl = this.settingsService.getApiUrl();
    const secureSiteApiUrl = this.settingsService.getSecureSiteApiUrl();
    

    const httpOptions = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Consumer-Application-Code': 'FWF',
      }),
    };

    await firstValueFrom(this.httpClient.get(`${secureSiteApiUrl}adobe`, httpOptions))
      .then(async (data: any) => {
        const { sPOID, poid } = data;
        this.meta.updateTag({ name: 'DCSext.poid', content: poid });
        this.meta.updateTag({ name: 'DCSext.sPoid', content: sPOID }); // Used for adobe analytics
        this.meta.updateTag({ name: 'WT.seg_6', content: data.crewFlag });
        this.windowRef.nativeWindow.spoid = sPOID;

        this.settingsService.setPoid(poid);
        const user = new User();
        user.poid = poid;
        user.lastLogin = Date.now();

        Promise.all([
          firstValueFrom(this.httpClient.get(`${apiUrl}/user`, { withCredentials: true })),
          firstValueFrom(
            this.httpClient.post(`${apiUrl}/user`, user, { withCredentials: true }),
          ),
        ])
          .then(([getUserData, postUserData]) => {
            console.log('GET USER success!', getUserData);
            console.log('POST USER success!', postUserData);
          })
          .catch((error) => {
            console.error('Error!', error);
          });
      })
      .catch((error) => {
        console.log('ADOBE REQUEST ERROR', error);
        return Promise.reject(new Error());
      });
  }

  sendToLogin(): void {
    const logonUrl = this.settingsService.getLogonUrl();
    const redirectUrl = this.settingsService.getLogonRedirectUrl();
    document.location.href = `${logonUrl}${redirectUrl}`;
  }
}
